import { render, staticRenderFns } from "./FeedBackLink.vue?vue&type=template&id=01a193f5&scoped=true&lang=pug&"
var script = {}
import style0 from "./FeedBackLink.vue?vue&type=style&index=0&id=01a193f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a193f5",
  null
  
)

export default component.exports